import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import PublisherSalesOrdersView from "../views/PublisherSalesOrdersView/PublisherSalesOrdersView";

export default function PublisherSalesOrders() {
	const { organization } = useOutletContext();

	const hasRight = useHasRight();

	// Publisher admins have orders.view; publisher staff do not.
	if (!hasRight("orders.view")) {
		return <Unauthorized />;
	}

	return <PublisherSalesOrdersView publisher={organization} />;
}
